import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type HeaderState = {
 headerTitle: string;
};

const initialState: HeaderState = {
 headerTitle: '',
};

const headerSlice = createSlice({
 name: 'header',
 initialState,
 reducers: {
  setHeaderTitle(state, action: PayloadAction<string>) {
   state.headerTitle = action.payload;
  },
  resetHeaderTitle(state) {
   state.headerTitle = '';
  },
 },
});

export const { setHeaderTitle, resetHeaderTitle } = headerSlice.actions;

export default headerSlice.reducer;
